// src/VendorManager.jsx
import React, { useState, useEffect } from 'react';
import {
  Container, Typography, Paper, TextField, Button, Box, Stack
} from '@mui/material';
import {
  collection, getDocs, setDoc, updateDoc, deleteDoc, doc
} from 'firebase/firestore';

import { db } from './firebase'; // ✅ use the already-initialized instance
const VENDOR_COLLECTION = 'vendors';

const VendorManager = () => {
  const [vendors, setVendors] = useState([]);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({
    id: '',
    name: '',
    contact_name: '',
    contact_email: '',
    phone: '',
    website: ''
  });

  const fetchVendors = async () => {
    const snapshot = await getDocs(collection(db, VENDOR_COLLECTION));
    const data = snapshot.docs.map(doc => ({ docId: doc.id, ...doc.data() }));
    setVendors(data);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    if (!form.id || !form.name) return;

    const ref = doc(db, VENDOR_COLLECTION, form.id);
    const payload = { ...form };

    editing
      ? await updateDoc(ref, payload)
      : await setDoc(ref, payload);

    await fetchVendors();
    setForm({ id: '', name: '', contact_name: '', contact_email: '', phone: '', website: '' });
    setEditing(null);
  };

  const handleEdit = (vendor) => {
    setEditing(vendor);
    setForm({ ...vendor, id: vendor.docId });
  };

  const handleDelete = async (id) => {
    await deleteDoc(doc(db, VENDOR_COLLECTION, id));
    await fetchVendors();
  };

  useEffect(() => {
    fetchVendors();
  }, []);

  return (
    <Container maxWidth="sm" sx={{ py: 6 }}>
      <Typography variant="h4" align="center" gutterBottom>
        🏷️ Vendor Manager
      </Typography>

      <Paper sx={{ p: 3, mb: 4 }} elevation={3}>
        <Stack spacing={2}>
          <TextField label="Vendor ID" name="id" value={form.id} onChange={handleChange} disabled={!!editing} />
          <TextField label="Vendor Name" name="name" value={form.name} onChange={handleChange} />
          <TextField label="Contact Name" name="contact_name" value={form.contact_name} onChange={handleChange} />
          <TextField label="Contact Email" name="contact_email" value={form.contact_email} onChange={handleChange} />
          <TextField label="Phone" name="phone" value={form.phone} onChange={handleChange} />
          <TextField label="Website" name="website" value={form.website} onChange={handleChange} />
          <Button variant="contained" onClick={handleSubmit}>
            {editing ? 'Update Vendor' : 'Add Vendor'}
          </Button>
        </Stack>
      </Paper>

      <Typography variant="h6">📋 Existing Vendors</Typography>
      <Stack spacing={2}>
        {vendors.map(vendor => (
          <Paper key={vendor.docId} sx={{ p: 2 }}>
            <Box display="flex" justifyContent="space-between">
              <div>
                <Typography fontWeight="bold">{vendor.name}</Typography>
                <Typography variant="caption" color="text.secondary">{vendor.docId}</Typography>
                <Typography variant="body2">📇 {vendor.contact_name} | 📧 {vendor.contact_email}</Typography>
                <Typography variant="body2">📞 {vendor.phone}</Typography>
                <Typography variant="body2">🔗 {vendor.website}</Typography>
              </div>
              <Stack direction="row" spacing={1}>
                <Button size="small" onClick={() => handleEdit(vendor)}>Edit</Button>
                <Button size="small" color="error" onClick={() => handleDelete(vendor.docId)}>Delete</Button>
              </Stack>
            </Box>
          </Paper>
        ))}
      </Stack>
    </Container>
  );
};

export default VendorManager;
